import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { frames } from '../../../Styles'
import { LoadingSpinner, PageHeader, WidgetModal } from '../../../Components'
import { WidgetPlacements } from '../../../Definitions'
import { useAppSelector } from '../../../Store'
import { Graph_QL, useAnimal, useWidget, Widget } from '../../../Services'
import { Pages } from '../../../Navigation/root'
import AllWidgets from '../../../Components/Widgets/_Widgets/allWidgets'
import { Animal } from '../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/GQLCalls/getAnimalCall'

export default function Kpi() {
  const { t } = useTranslation();
  const [widgetModal, setWidgetModal] = useState<boolean>(false);

  // #region | GraphQL
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const { domain, connection } = useMemo(() => {
    let domain = Graph_QL.ObjToString({ domain: farm });
    let connection = Graph_QL.create({ domain: farm });
    return { domain, connection };
  }, [farm]);

  const { call: getWidgetInfo, data: widgetState } = useWidget(connection);
  const { call: getAnimals, data: animalState } = useAnimal(connection)

  useEffect(() => {
    getWidgetInfo({}, connection);
    getAnimals({ ifSkipLastTenDaysConsumption: false, offset: 0}, connection)
  }, [connection]);

  const widgets = useMemo<Widget[]>(() => { return widgetState[domain]?.data ?? [] }, [widgetState, domain])
  const animals = useMemo<Animal[]>(() => { return animalState[domain]?.data ?? [] }, [animalState, domain])
  // #endregion

  return (
    <frames.Page_inner>
      <PageHeader
        zIndex={1}
        topHeader={t(`menuHeaders.${Pages.kpi}`, { defaultValue: "kpi" })}
        subHeader={t("menuHeaders.overview", { defaultValue: "overview" })}
        optionButtons={{
          contents: [t("widgets.general.widgetOptions", {defaultValue: "widget options"})],
          onClick: (i => { if (i === 0) { setWidgetModal(true) } })
        }}
      />
      <frames._page_inner_content_scroll>
        <AllWidgets
          animals={animals}
          widgets={widgets}
          placement={WidgetPlacements.kpi}
          connect={{
            domain: domain,
            connection: connection
          }}
          overrides={{
            columnCount: widgets.length === 1 ? 1 : 2
          }}
        />
      </frames._page_inner_content_scroll> 
      <WidgetModal widgets={widgets} closeModal={() => setWidgetModal(false)} connect={{connection: connection, domain: domain}} isModalOpen={widgetModal} placement={WidgetPlacements.kpi}/>
    </frames.Page_inner>
  );
}